












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Drift from 'drift-zoom';
import { ProductImageDto } from '@/api';
import { Urls } from '@/util/Urls';

@Component
export default class ZoomableImage extends Vue {

  @Prop({required: true})
  public image!: ProductImageDto;

  @Prop({required: false, default: null})
  public namespace!: string | null;

  @Prop({required: false, default: false})
  public handleTouch!: boolean;

  @Prop({required: false, default: null})
  public zoomFactor!: number | null;

  private urls = Urls;
  private drift: Drift | null = null;
  private customStyleSheet: CSSStyleSheet | null = null;
  private customStyle: HTMLStyleElement | null = null;

  @Watch('image')
  public mountDrift() {
    const image = this.$refs.baseImage as HTMLImageElement;
    this.unmountStyleSheet();
    if (this.drift) {
      this.drift.destroy();
    }
    const options = {
      paneContainer: this.$refs.paneContainer,
      hoverBoundingBox: true,
      handleTouch: this.handleTouch,
      inlinePane: false,
      containInline: true,
      namespace: this.namespace,
      inlineOffsetX: 0,
      inlineOffsetY: 0,
      showWhitespaceAtEdges: false,
      onShow: null,
      zoomFactor: this.zoomFactor,
    };
    this.drift = new Drift(image, options);


    this.customStyle = document.createElement('style');
    // WebKit hack :(
    this.customStyle.appendChild(document.createTextNode(''));
    document.head.appendChild(this.customStyle);
    this.customStyleSheet = this.customStyle.sheet as CSSStyleSheet;

    this.customStyleSheet.insertRule(
      `.product-image-modal-inline {
        z-index: 999;
        height: ${image.clientHeight}px;
        width: ${image.clientWidth}px;
    }`, 0);
  }

  private beforeDestroy() {
    this.unmountStyleSheet();
    this.drift?.destroy();
  }


  private destroyed() {
    let elementsToRemove = document.getElementsByClassName('product-zoom-open');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elementsToRemove.length; i++) {
      document.body.removeChild(elementsToRemove[i]);
    }

    elementsToRemove = document.getElementsByClassName('product-zoom-inline');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elementsToRemove.length; i++) {
      document.body.removeChild(elementsToRemove[i]);
    }
  }


  private unmountStyleSheet() {
    this.customStyleSheet?.deleteRule(0);
    if (this.customStyle) {
      document.head.removeChild(this.customStyle);
    }
  }

  public handleTap() {
    this.$emit('click');
  }
}
